module.exports = __webpack_public_path__ + "static/media/LHAOutSwingDark.b5d5c3b7.svg";